app.controller("OnlineOfferSearchResultAreaController",
	["$scope", "$filter", "$sce", "OnlineOfferSearchService", function($scope, $filter, $sce, OnlineOfferSearchService) {

		$scope.searchID = "";
		$scope.searchResults = OnlineOfferSearchService.results[$scope.searchID];

		$scope.$watch('searchResults.loading', function(newVal) {

		});

		$scope.Init = function(searchID) {
			$scope.searchID = searchID;
			if(OnlineOfferSearchService.results[searchID] === undefined) {
				OnlineOfferSearchService.results[searchID] = {};
			}
			$scope.searchResults = OnlineOfferSearchService.results[searchID];
		};


		/**
		 * Get a class for the result type (house, rowhouse, etc).
		 * @param result
		 */
		$scope.getResultTypeClass = function(result) {
			var buildingType = OnlineOfferSearchService.ResolveBuildingType(result.buildingType);
			if(buildingType === undefined) {
				return "";
			}
			return buildingType.type;
		};


		/**
		 * Get the living area or the lot area of a result.
		 * @param result
		 */
		$scope.getArea = function(result) {
			var stringBuildingType = OnlineOfferSearchService.ResolveBuildingType(result.buildingType);
			if(stringBuildingType.type == 'lot' || (stringBuildingType.type == 'ranch' && result.livingArea == null)) {
				var lotAreaType = result.lotAreaType.replace(/(\D+)(\d)/, "$1<sup>$2</sup>");
				return $sce.trustAsHtml(result.lotArea + " " + lotAreaType.toLowerCase());
			}
			else {
				return $sce.trustAsHtml(result.livingArea + ' m<sup>2</sup>');
			}
		};

		/**
		 * Get the building type description.
		 * @param result
		 * @returns {*}
		 */
		$scope.getType = function(result) {
			var buildingType = OnlineOfferSearchService.ResolveBuildingType(result.buildingType);
			if(buildingType === undefined) {
				return "";
			}
			return buildingType.description;
		};

		/**
		 * Get the location string from a result.
		 * @param result
		 */
		$scope.getLocation = function(result) {
			if(result.district === "" || result.district == null) {
				return result.municipality;
			}
			return result.district + ", " + result.municipality;
		};

		/**
		 * Get the offer date from a date object in API format.
		 * @param date
		 */
		$scope.getOfferDate = function (date) {
			return $filter('date')(date.sec * 1000, 'dd.MM.yyyy');
		};

		/**
		 * Get a nicely formatted sale time from a result's timespan.
		 * @param result
		 */
		$scope.getSaleTime = function(result) {

			var dayDisplayLimit = 21;
			var weekDisplayLimit = 90;

			if(result.saleDays >= dayDisplayLimit && result.saleDays <= weekDisplayLimit) {
				var weeks = Math.floor(result.saleDays / 7);
				var days = result.saleDays % 7;
				var str = weeks + " viikkoa";
				if(days > 0) {
					str += " " + days + " päivää";
				}
				return str;
			}
			if(result.saleDays > weekDisplayLimit) {
				return Math.floor(result.saleDays / 30) + " kuukautta";
			}

			return result.saleDays + " päivää";
		};

		/**
		 * Get the starting price (lowest offered?) of a result.
		 * @param result
		 * @returns {string}
		 */
		$scope.getStartingPrice = function(result) {
			// Nykyään on salesPriceUnencumbered, jos se löytyy, käytetään sitä. Ei-tarjouskauppakohteissa se näyttää olevan pyyntihinta.
			var amount = 0;
			if (result.salesPriceUnencumbered !== undefined) {
				amount = result.salesPriceUnencumbered;
			} else if (result.smallestOffer !== undefined) {
				amount = result.smallestOffer;
			} else {
				var olen = result.onlineOffers.offers.length;
				var offer = result.onlineOffers.offers[olen - 1];
				amount = offer.amount;
			}
			return $filter('currency')(amount, '', ',', ' ', 0) + " €";
		};


		/**
		 * Get the type of the starting price.
		 * @param result
		 * @returns {*}
		 */
		$scope.getStartingPriceType = function(result) {
			// Jos meillä on lähtöhinta, ei kyseessä ole tarjous, joten ei palauteta tyyppiä.
			if (result.salesPriceUnencumbered !== undefined) {
				return '';
			} else if (result.smallestOffer !== undefined) {
				for (var i in result.onlineOffers.offers) {
					if (result.onlineOffers.offers.hasOwnProperty(i)) {
						if (result.smallestOffer == result.onlineOffers.offers[i].amount) {
							return $scope.getOfferType(result.onlineOffers.offers[i]);
						}
					}
				}
			} else {
				var olen = result.onlineOffers.offers.length;
				var offer = result.onlineOffers.offers[olen - 1];
				return $scope.getOfferType(offer);
			}
			return '';
		};

		$scope.getOfferType = function(offer) {
			return offer.conditional ? "Ehdollinen" : "Kirjallinen";
		};

		/**
		 * Get the highest offer.
		 * @param result
		 * @returns {string}
		 */
		$scope.getHighestOffer = function(result) {
			var amount = 0;
			if (result.largestOffer !== undefined) {
				amount = result.largestOffer;
			} else {
				var offer = result.onlineOffers.offers[0];
				amount = offer.amount;
			}
			return $filter('currency')(amount, '', ',', ' ', 0) + " €";
		};

		/**
		 * Get highest offer type.
		 * @param result
		 * @returns {*}
		 */
		$scope.getHighestOfferType = function(result) {
			if (result.largestOffer !== undefined) {
				for (var i in result.onlineOffers.offers) {
					if (result.onlineOffers.offers.hasOwnProperty(i)) {
						if (result.largestOffer == result.onlineOffers.offers[i].amount) {
							return $scope.getOfferType(result.onlineOffers.offers[i]);
						}
					}
				}
			} else {
				var offer = result.onlineOffers.offers[0];
				return $scope.getOfferType(offer);
			}
			return '';
		};

		$scope.getOfferers = function(offer) {
			var offerers = [];
			for(var i = 0; i < offer.customers.length; i++) {
				offerers.push("Tarjoaja " + offer.customers[i]);
			}
			return offerers;
		};

		$scope.getOfferAmount = function(offer) {
			return $filter('currency')(offer.amount, '', ',', ' ', 0) + " €";
		};

	}]

);